export type Option<T = string | number> = {
  label: string;
  value: T;
};
export type IdName = {
  id: number;
  name: string;
};

function idNameToOption <T = string | number>(item: IdName): Option<T> {
  return {
    label: item.name,
    value: item.id as T,
  };
}

export function idNamesToOptions<T = string | number>(items: IdName[]): Option<T>[] {
  return items.map((item) => idNameToOption<T>(item));
}
